import React from 'react';
import { ShoppingCart, Truck, PhoneCall, ArrowRight, Facebook, MapPin, Phone } from 'lucide-react';
import { motion } from 'framer-motion';

const HowToBuy = () => {
  const steps = [
    {
      icon: <ShoppingCart className="text-white" size={32} />,
      title: '1. Vælg materiale',
      description: 'Find det materiale du skal bruge i vores prisoversigt eller ring og få rådgivning.',
    },
    {
      icon: <Truck className="text-white" size={32} />,
      title: '2. Besøg Grenå eller Glesborg',
      description: 'Afhent direkte på pladsen med din trailer. Vi hjælper gerne med læsning.',
    },
    {
      icon: <PhoneCall className="text-white" size={32} />,
      title: '3. Kontakt os ved spørgsmål',
      description: 'Er du i tvivl om mængde eller type? Ring til os eller skriv på Facebook.',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <section id="guide" className="py-16 bg-[#4e341b] text-white overflow-hidden relative">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-dark rounded-full -mr-32 -mt-32 blur-3xl opacity-50"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full -ml-48 -mb-48 blur-3xl opacity-30"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-left md:text-center mb-12"
        >
          <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-4 text-white">Sådan handler du hos os</h2>
          <p className="text-lg text-white/80 max-w-2xl md:mx-auto">
            Det er enkelt og hurtigt at få de rigtige materialer med hjem.
          </p>
        </motion.div>

        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-3 gap-12 mb-12"
        >
          {steps.map((step, index) => (
            <motion.div key={index} variants={itemVariants} className="relative">
              <div className="w-16 h-16 flex items-center justify-start md:justify-center mb-4">
                {step.icon}
              </div>
              <h3 className="text-xl font-black uppercase mb-3">{step.title}</h3>
              <p className="text-white/80 leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="flex flex-wrap justify-start md:justify-center gap-4"
        >
          <a
            href="tel:+4520181271"
            className="flex items-center gap-2 bg-white text-black px-8 py-4 rounded-none font-bold text-lg hover:bg-zinc-100 transition-all shadow-lg"
          >
            <Phone size={20} />
            Ring nu
          </a>
          <a
            href="#lokationer"
            className="flex items-center gap-2 bg-black border border-white/20 text-white px-8 py-4 rounded-none font-bold text-lg hover:bg-zinc-900 transition-all shadow-lg"
          >
            <MapPin size={20} />
            Find vej
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default HowToBuy;
